// OidcProviderClientSide.tsx
import React, {ReactNode} from 'react';
import {OidcProvider} from '@axa-fr/react-oidc';
import {configurationIdentityServer} from '../configs/identConfig.ts'; // Pfad überprüfen

interface OidcProviderClientSideProps {
    children: ReactNode;
}

const OidcProviderClientSide: React.FC<OidcProviderClientSideProps> = ({children}) => {
    return <OidcProvider configuration={configurationIdentityServer}>{children}</OidcProvider>;
};

export default OidcProviderClientSide;
